/* Hatgoods — coming soon countdown
   Upgrades the Liquid-rendered countdown to a live ticking one and removes
   the overlay the moment the launch time passes, without a page reload.
   Times are stored with a +06:00 offset, so this stays correct for visitors
   in any timezone. */

(function () {
  var TICK = 30000; // 30s — minutes are the smallest unit shown

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function reveal(overlay) {
    var card = overlay.closest('.card') || overlay.closest('.card-wrapper');
    overlay.remove();
    if (card) {
      card.querySelectorAll('img').forEach(function (img) {
        img.style.filter = 'none';
        img.style.transform = '';
      });
    }
  }

  function update(overlay) {
    var launch = new Date(overlay.dataset.launch);
    if (isNaN(launch)) return;

    var left = Math.floor((launch.getTime() - Date.now()) / 1000);

    if (left <= 0) {
      reveal(overlay);
      return;
    }

    var days = Math.floor(left / 86400);
    var hours = Math.floor((left % 86400) / 3600);
    var mins = Math.floor((left % 3600) / 60);

    var clock = overlay.querySelector('[data-hg-clock]');
    if (clock) {
      var d = clock.querySelector('[data-unit="d"]');
      var h = clock.querySelector('[data-unit="h"]');
      var m = clock.querySelector('[data-unit="m"]');
      if (d) d.textContent = pad(days) + 'd';
      if (h) h.textContent = pad(hours) + 'h';
      if (m) m.textContent = pad(mins) + 'm';
    }

    var tag = overlay.querySelector('.hg-cs__tag--ruby');
    if (tag) {
      tag.textContent =
        days >= 1 ? days + (days === 1 ? ' day left' : ' days left') : 'Drops today';
    }
  }

  function run() {
    var overlays = document.querySelectorAll('.hg-cs[data-launch]');
    if (!overlays.length) return;
    overlays.forEach(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  setInterval(run, TICK);

  // Re-run after a section re-renders (filters, load more, quick view)
  document.addEventListener('shopify:section:load', run);
})();